import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { FooterLinksConfig } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FOOTER_LINKS: DiToken<() => FooterLinksConfig> = new DiToken<() => FooterLinksConfig>('FOOTER_LINKS', {
  factory: () => () => []
});
